import { useRef, useState } from "react";
import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { ContentSection } from "../../components/content-section/ContentSection";
import { ContentContainer } from "../../components/content-container/ContentContainer";
import DataFileImportList, { DataFileImportListType } from "./data-file-import-list/DataFileImportList";
import { actionItems } from "./DataFileImportUtils";
import { ActionMenuItem, BaseActions } from "../../components/action-menu/ActionMenuItem";
import { DataFileImportActionEnum } from "./data-file-import-list/DataFileImportListUtils";

export default function DataFileImportView() {

    const routeContext = useRouteContext();
    const [viewOptionState, setViewOptionState] = useState(ViewOptionStateEnum.Default);

    const importListRef = useRef<DataFileImportListType>(undefined);

    function onExecuteAction(menuItem: ActionMenuItem) {

        const action = menuItem.action as BaseActions | DataFileImportActionEnum;
        importListRef.current?.executeAction(action);
    }

    return (
        <ContentView>
            <ContextualAppBar 
                hideBreadcrumb={true}
                actions={actionItems} 
                viewOptionState={viewOptionState}
                onExecuteAction={onExecuteAction} 
            />

                <ContentContainer>
                    <ContentSection>

                        <DataFileImportList
                            ref={importListRef}
                            groupID={routeContext.groupID as number} 
                            setViewOptionState={setViewOptionState}
                            />

                    </ContentSection>

                </ContentContainer>

        </ContentView>
    );
  }
